import { useRouter } from 'next/router'

export const useActiveSbirId = () => {
  const router = useRouter()
  const activeSbirId = router.query.sbirId || ''
  return {
    activeSbirId: typeof activeSbirId === 'string' ? activeSbirId : '',
  }
}
